import React from 'react';
import { GrClose } from 'react-icons/gr';
import { Col, Container, Row } from 'react-bootstrap';
import Images from '../../Assets/Images/Images';
import './Navigation.scss';
import NavMenu from '../NavMenu/NavMenu';

const Navigation = ({ show, setShowNav }) => {
  const showClass = show ? 'show' : '';

  return (
    <div className={`navigation ${showClass}`}>
      <div className='navigation__image-wrapper'>
        <div
          className='navigation__image'
          style={{
            backgroundImage: `url(${Images.menu})`
          }}
        />
      </div>
      <div className='navigation__content-wrapper'>
        <div className='navigation__content'>
          <div className='navigation__close-wrapper'>
            <button
              className='navigation__close'
              onClick={() => setShowNav(false)}
            >
              <GrClose size='1.5em' />
            </button>
          </div>
          <NavMenu
            showClass={showClass}
            handleClick={() => setShowNav(false)}
          />
          <div className='navigation__content--bottom'>
            <Container>
              <Row>
                <Col xs={{ span: 12, order: 1 }} md={{ span: 6, order: 1 }} lg={5}>
                  <p>House Of Arie 1</p>
                </Col>
                <Col xs={{ span: 12, order: 3 }} md={{ span: 6, order: 2 }} lg={{ span: 5, offset: 1 }}>
                  <p>House Of Arie 2</p>
                </Col>
                <Col xs={{ span: 12, order: 2 }} md={{ span: 6, order: 3 }} lg={5}>
                  <p>Jl. Depsos Gg. H. Mardan No.72, RW.1, Bintaro, Kec. Pesanggrahan, Kota Jakarta Selatan, Daerah Khusus Ibukota Jakarta 12330</p>
                </Col>
                <Col xs={{ span: 12, order: 4 }} md={{ span: 6, order: 4 }} lg={{ span: 5, offset: 1 }}>
                  <p>Jl. Bhakti No.5, RT. 006/01, Bintaro, Pesanggrahan, Jakarta Selatan, DKI Jakarta Selatan</p>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navigation;
